import { useNavigate } from 'react-router';
import { Button, Text } from '~/commonComponents';
import { getShouldEnforcePermanentJobV2 } from '~/growthbook';
import { Colors, TColorKeys } from '~/themes/colors';
import { type CSSProperties } from 'react';
import PlusIcon from '~/images/icons/PlusIcon';

interface ICreatePostingButtonProps {
  text?: string;
  variant?: 'default' | 'lite';
  style?: CSSProperties;
  textStyle?: CSSProperties;
  loadingColor?: TColorKeys;
  dataCy?: string;
  onTrack?: (postingId?: string) => void;
}

const Styles = {
  Lite: {
    Button: {
      alignItems: 'center',
      backgroundColor: Colors.secondary_500,
      borderRadius: 25,
      boxShadow: '0 2px 3px 0 rgba(0, 0, 0, 0.15), 0 6px 10px 2px rgba(0, 0, 0, 0.15)',
      display: 'inline-flex',
      flexShrink: 0,
      gap: 4,
      height: 30,
      justifyContent: 'center',
      padding: '8px 12px',
    } as CSSProperties,
  },
};

export const CreatePostingButton: React.FC<ICreatePostingButtonProps> = ({
  text = 'Post a Job',
  variant = 'default',
  style,
  textStyle,
  loadingColor,
  dataCy = 'create-perm-job-button',
  onTrack,
}: ICreatePostingButtonProps) => {
  const navigate = useNavigate();

  const handleCreateDraft = () => {
    onTrack?.();
    navigate('/permanent-jobs/value-proposition');
  };

  if (!getShouldEnforcePermanentJobV2()) {
    return null;
  }

  if (variant === 'lite') {
    return (
      <button
        data-testid="create-permanent-job-button"
        data-cy={dataCy}
        style={Styles.Lite.Button}
        onClick={handleCreateDraft}
      >
        <PlusIcon color={Colors.white} />
        <Text bold color={Colors.white} textAlign="center">
          {text}
        </Text>
      </button>
    );
  }

  return (
    <Button
      data-testid="create-permanent-job-button"
      dataCy={dataCy}
      text={text}
      textStyle={textStyle}
      style={{ width: 206, marginTop: 0, ...style }}
      isLoading={false}
      loadingColor={loadingColor}
      onClick={handleCreateDraft}
    />
  );
};
